module.exports = __webpack_public_path__ + "img/pic_features_4.5891e6d2.png";